// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1z8JC","messages":"Chat_messages__1T5ye","dateDivider":"Chat_dateDivider__2fIOg"};